import React from 'react'

const TutorRoute = ({children}) => {
  return children;
}

export default TutorRoute